<template>
  <div>
    <template v-if="getMerchant.booking_engine_header_type == 'BANNER'">
      <div class="bg-top-black position-absolute d-table no-ws pl-3 cursor-pointer" @click="backToHomepage()" style="left: 0">
        <img src="../../../assets/img/icon/back-white.png" height="20" class="d-inline-block align-middle">
        <p
          class="mb-0 body-2-2 p-3 text-white font-semibold d-inline-block align-middle">
          Back to Homepage
        </p>
      </div>

      <div class="bg-top-black position-absolute d-table" style="right: 0">
        <p  
          @click="toggleShowLanguagePopup(true)" 
          class="mb-0 body-2-2 p-3 text-white font-semibold cursor-pointer">
          <span>{{$t('hotel.language')}}</span> | {{getCurrency.name}} ({{getCurrency.code}}) 
        </p>
      </div>

      <!-- header image -->
      <div class="bg-white py-5 bg-room" id="search" :style="{'background-image': 'url(' + getMerchant.booking_engine_hero_banner + ')' }">
        <div class="container-desktop pb-3 mt-3">
          <template v-if="getMerchant.search_room_is_show_merchant_image">
            <img :src="getMerchant.image_url" class="mx-auto d-table" :style="{width: getMerchant.search_room_merchant_image_width + 'px'}">
          </template>
          <p v-if="getMerchant.search_room_is_show_merchant_name" class="mb-0 body-2-2 text-40 font-extrabold text-center text-white text-shadow">{{getMerchant.name}}</p>
          <div class="mx-auto d-table" v-if="getMerchant.search_room_is_show_merchant_star">
            <img src="../../../assets/img/icon/hotel-star.png" width="20" class="d-inline-block mb-3" v-for="data in getMerchant.star">
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="getMerchant.booking_engine_header_type == 'NAVBAR'">
      <TopNavbar @openCurLang="toggleShowLanguagePopup" @backClicked="backToHomepage" />
    </template>
    <template v-else-if="getMerchant.booking_engine_header_type == 'MULTI_IMAGE_BANNER'">
      <HotelTopNavbar page="booking" />
      <block :height="$is_mobile_view ? 80 : 100" />

      <div class="ga-container fluid mb-4 mb-lg-5">
        <!-- HOTEL IMAGE -->
        <div class="w-100" v-if="getMerchant.merchant_images.length > 0">
          <div class="row slim-grid-row-1">
            <div class="col-12" v-if="getMerchant.merchant_images.length < 4">
              <div class="w-100 position-relative">
                <div v-if="getMerchant.merchant_images.length == 1" class="w-100 h-400">
                  <img :src="getMerchant.merchant_images[0].image_url" class="img-fit cursor-pointer h-400 radius-8" :alt="getMerchant.name" @click="selectMerchantImageIndex(0)">
                </div>
                <flickity v-else ref="flickity" :options="$fullSliderOption">
                  <div class="carousel-cell w-100" :id="slider_merchant.id" v-for="(slider_merchant,slider_merchant_index) in  getMerchant.merchant_images">
                    <div class="w-100 h-400">
                      <img :src="slider_merchant.image_url" class="img-fit h-400 radius-8 cursor-pointer" :alt="getMerchant.name" @click="selectMerchantImageIndex(slider_merchant_index)">
                    </div>
                  </div>
                </flickity>

                <button v-if="getMerchant.merchant_images.length > 1" @click="selectMerchantImageIndex(0)" type="button" class="g-btn bg-white g-btn-sm px-2 cursor-pointer button-more-image rounded">{{$t('general.view-all')}} ({{getMerchant.merchant_images.length}})</button>
              </div>
            </div>
            <template v-else>
              <div class="col-xl-8 col-6 col-sm-7">
                <img :src="getMerchant.merchant_images[0].image_url" class="w-100 img-slider-1 h-400 cursor-pointer" :alt="getMerchant.name" @click="selectMerchantImageIndex(0)">
              </div>
              <div class="col-xl-4 col-6 col-sm-5 h-400 overflow-hidden">
                <div class="row slim-grid-row-1">
                  <div class="col-12 mb-2">
                    <div class="row slim-grid-row-1">
                      <div class="col-6">
                        <img :src="getMerchant.merchant_images[1].image_url" class="w-100 img-slider-2 cursor-pointer" :alt="getMerchant.name" @click="selectMerchantImageIndex(1)">
                      </div>
                      <div class="col-6">
                        <img :src="getMerchant.merchant_images[2].image_url" class="w-100 img-slider-3 cursor-pointer" :alt="getMerchant.name" @click="selectMerchantImageIndex(2)">
                      </div>
                    </div>
                  </div>
                  <div class="col-12 position-relative">
                    <img :src="getMerchant.merchant_images[3].image_url" class="w-100 img-slider-4 cursor-pointer" :alt="getMerchant.name" @click="selectMerchantImageIndex(3)">
                    <button v-if="getMerchant.merchant_images.length > 4" @click="selectMerchantImageIndex(0)" type="button" class="g-btn bg-white g-btn-sm px-2 cursor-pointer button-more-image rounded">{{$t('general.view-all')}} ({{getMerchant.merchant_images.length}})</button>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>

    <GeneralLanguageCurrency :showPopup="showLanguagePopup" @togglePopup="toggleShowLanguagePopup" />

    <CoolLightBox 
      :items="getMerchant.merchant_images" 
      srcName="image_url" 
      :index="activeMerchantImageIndex"
      closeOnClickOutsideMobile
      @close="activeMerchantImageIndex = null">
    </CoolLightBox>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import config from '@/config/index.js'
  import TopNavbar from '@/components/hotel/be/desktop/navbar'
  import GeneralLanguageCurrency from '../../general/GeneralLanguageCurrency.vue';
  import GeneralTopNavbar from '../../general/GeneralTopNavbar.vue';
  import HotelProductTab from '../HotelProductTab.vue';
  import HotelTopNavbar from '../HotelTopNavbar.vue';
  import CoolLightBox from 'vue-cool-lightbox'
  import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

  export default {
    components:{
      TopNavbar,
      GeneralLanguageCurrency,
      GeneralTopNavbar,
      HotelProductTab,
      HotelTopNavbar,
      CoolLightBox
    },
    data(){
      return{
        showLanguagePopup: false,
        activeMerchantImageIndex: null
      }
    },
    computed:{
      ...mapGetters(['getMerchant', 'getCurrency']),
      showGroup(){
        const { community } = this.getMerchant;
        const communityId = this.$isNotEmptyV2(community.id) ? community.id : community
        const isCommunityDefault = config.COMMUNITY_SYSTEM === communityId
        
        const isAllowedCommunity = () => {
          let allowedCommunity = ['coinfestasia', 'baliblockchainsummit', 'ghr']
          return allowedCommunity.some(cmnt => cmnt === community.code)
        }

        const isTestCommunity = () => {
          let isTestCommunityCode = community.code.substring(0, 11)
          return isTestCommunityCode == 'testing-gp-'
        }  

        return this.$app_env == 'prod' && !isCommunityDefault && !isAllowedCommunity() && !isTestCommunity()
      },
    },
    methods:{
      backToHomepage(){
        if(this.showGroup) {
          window.open(`${window.location.origin}/${this.getMerchant.community.code}/group`, '_self');
        }
        
        const useCustomHomepageUrl = this.getMerchant.search_room_custom_homepage_url ;
        if(this.$isNotEmptyV2(useCustomHomepageUrl)){
          this.$openLink(useCustomHomepageUrl)
          return;
        }

        this.$router.push(`/${this.getMerchant.code}`);
      },
      toggleShowLanguagePopup(show=false){
        this.showLanguagePopup = show
      },
      selectMerchantImageIndex(index){
        this.activeMerchantImageIndex = index
      }
    }
  }
</script>
<style setup>
  .h-400{
    height: 200px !important;
  }
  .img-slider-1{
    object-fit: cover;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .img-slider-2{
    height: 96px;
  }
  .img-slider-3{
    height: 96px;
    border-top-right-radius: 4px;
  }
  .img-slider-4{
    height: 96px;
    border-bottom-right-radius: 4px;
  }
  .button-more-image{
    position: absolute;
    bottom: 8px;
    right: 12px;
  }

  @media screen and (min-width: 768px) {
    .h-400{
      height: 300px !important;
    }
    .img-slider-1{
      object-fit: cover;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    .img-slider-2{
      height: 146px;
    }
    .img-slider-3{
      height: 146px;
      border-top-right-radius: 4px;
    }
    .img-slider-4{
      height: 146px;
      border-bottom-right-radius: 4px;
    }
    .button-more-image{
      bottom: 16px;
      right: 20px;
    }
  }

  @media screen and (min-width: 1024px) {
    .h-400{
      height: 400px !important;
    }
    .img-slider-1{
      object-fit: cover;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }
    .img-slider-2{
      height: 196px;
    }
    .img-slider-3{
      height: 196px;
      border-top-right-radius: 8px;
    }
    .img-slider-4{
      height: 196px;
      border-bottom-right-radius: 8px;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/hotel/be/SearchRoomHeader.vue